export default "__VITE_ASSET__16492098__"